module.exports = __webpack_public_path__ + "static/media/19.926d8f52.png";